module.exports = __webpack_public_path__ + "static/img/school_banner.bfa5217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/school_banner.png
// module id = hy13
// module chunks = 34